import { getOrganizationConfigByDomain } from "../../shared/utils/Global";

import { AccessMode } from "./types";

let cachedMode: AccessMode | null = null;

/**
 * Resolves the tenant's access mode once per session.
 *
 * - AccessMode.Rbac     → visibility answered from the Casbin-derived permission maps
 * - AccessMode.UiConfig → visibility answered from the UI-config / ui-permissions APIs
 *
 * Reads `renderStrategy.accessMode` on OrganizationConfig; defaults to Rbac
 * when a tenant hasn't set one. Target: served by /fetch-login-config.
 */
export function getAccessMode(): AccessMode {
  if (cachedMode) return cachedMode;
  const organizationConfig = getOrganizationConfigByDomain();
  cachedMode =
    organizationConfig?.renderStrategy?.accessMode ?? AccessMode.Rbac;
  return cachedMode;
}

/** Test-only: clear the memoized mode (hostname never changes at runtime). */
export function resetAccessModeForTests(): void {
  cachedMode = null;
}
